import { ClientSocietySelect } from "@dune/vars";

export const isSocietySyndic = (society: ClientSocietySelect) => {
	return society.syndicConstructionSites?.length > 0;
};